import { useRouter } from "next/router";
import { staticRequest } from "tinacms";
import { useTina } from "tinacms/dist/react";
import { TinaMarkdown } from "tinacms/dist/rich-text";

import { BoxSection } from "../components/Box";
import { Layout } from "../components/layout/Layout";
import { getAboutPageJsonLd } from "../components/layout/head/getAboutPageJsonLd";
import { useT } from "../src/translations";

/* eslint-disable prettier/prettier */

const getQuery = (locale: string) => ({
  query:`
  query getAbout($relativePath: String!) {
    page(relativePath: $relativePath) {
      body
      title
      description
    }
  }`,
  variables: {
    relativePath: `${locale === "fr" ? "fr/" : ""}about.mdx`,
  },
});

/* eslint-enable prettier/prettier */

export default function AboutPage(props: { data: any; query: any }) {
  const { data } = useTina({
    query: props.query,
    variables: {},
    data: props.data,
  });

  const page = data.page.body;
  const { title, description } = data.page;
  const t = useT();
  const { locale } = useRouter();

  return (
    <Layout
      title={title}
      description={description}
      jsonLd={getAboutPageJsonLd({ locale })}
    >
      <article>
        <BoxSection>
          <TinaMarkdown content={page} />
        </BoxSection>
        <BoxSection>
          {t.pages.about.moreInfo1}
          {t.pages.about.moreInfo2}
        </BoxSection>
      </article>
    </Layout>
  );
}

export const getStaticProps = async (ctx) => {
  const query = getQuery(ctx.locale);
  const data = await staticRequest({ ...query });

  return {
    props: {
      ...query,
      data,
    },
  };
};
